<template>
    <div>
        <template v-if="canRegister">
            <div class="row gx-3 gy-2">
                <div class="col-auto">
                    <router-link :to="registerRoute" custom v-slot="{ href }">
                        <a :href="href" class="btn btn-primary btn-lg text-uppercase">
                            {{ buttonLabel }}
                            <Icon name="arrow-down" width=".75em" height=".75em" class="align-baseline ml-3" style="transform: rotate(-90deg)" />
                        </a>
                    </router-link>
                </div>
                <template v-if="hasQuoteButton">
                    <div class="col-auto d-print-none">
                        <router-link :to="quoteRoute" custom v-slot="{ href }">
                            <a :href="href" class="btn btn-secondary btn-lg text-uppercase">
                                Je demande un devis
                            </a>
                        </router-link>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <button class="btn btn-secondary btn-lg text-uppercase" disabled>
                {{ buttonLabel }}
            </button>
        </template>

        <div class="mt-2">
            <div>
                <template v-if="canRegister">
                    <div class="small">
                        <template v-if="session.gauge">
                            <div class="mb-1">
                                <SessionGaugeLabel :session="session" />
                            </div>
                        </template>
                        <template v-if="session.registration_deadline">
                            <div class="mb-1">
                                <SessionDeadlineLabel :course="course" :session="session" />
                            </div>
                        </template>
                        <template v-if="!course.is_free">
                            <div class="mb-1 text-muted">
                                (pour les financements par un organisme tiers, le dépôt du dossier doit s’effectuer avant la date limite d’inscription ; par précaution prévoir un délai suffisant)
                            </div>
                        </template>
                    </div>
                </template>
                <template v-else>
                    <SessionStateLabel :session="session" />
                </template>
            </div>
            <div class="mt-1 text-muted small">
                <template v-if="session.short_description">
                    <div class="mt-1" v-html="session.short_description">
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
  import SessionDeadlineLabel from "../../SessionDeadlineLabel.vue";
  import SessionStateLabel from "../../SessionStateLabel.vue";
  import Icon from "../../ui/Icon.vue";
  import SessionGaugeLabel from "../../SessionGaugeLabel.vue";
  import { hasQuote, registerButtonLabel, sessionRegisterRoute } from "../../../util/register";

  export default {
        components: {
            SessionGaugeLabel,
            Icon,
            SessionStateLabel,
            SessionDeadlineLabel,
        },
        props: {
            course: Object,
            session: Object,
        },
        computed: {
            hasQuoteButton() {
                return hasQuote({ course:this.course, session:this.session });
            },
            canRegister() {
                return this.session.state === 'OK';
            },
            buttonLabel() {
                return registerButtonLabel(this.course);
            },
            registerRoute() {
                return sessionRegisterRoute({
                    course: this.course,
                    session: this.session,
                });
            },
            quoteRoute() {
                return sessionRegisterRoute({
                    course: this.course,
                    session: this.session,
                    isQuote: true,
                });
            }
        }
    }
</script>
